import { useEffect, useState } from "react";
import { IScopeOptions } from "../@types";
import { exportScopeValues } from "../const";

const useExportScope = (hasSelectedRows: boolean) => {
  const [exportScope, setExportScope] = useState<IScopeOptions>(
    exportScopeValues.PAGE
  );

  useEffect(() => {
    if (hasSelectedRows && exportScope === exportScopeValues.PAGE) {
      setExportScope(exportScopeValues.SELECTED);
    } else if (!hasSelectedRows && exportScope === exportScopeValues.SELECTED) {
      setExportScope(exportScopeValues.PAGE);
    }
  }, [hasSelectedRows]);

  return { exportScope, setExportScope };
};

export default useExportScope;
